import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
// todo: remove useTranslation
import { useTranslation } from 'react-i18next';

interface ToolbarToggleButtonProps extends ButtonProps {
  isOpen: boolean;
  onToggleState: (state: boolean) => void; 
  showLabel?: string;
  hideLabel?: string;
}

export const ToolbarToggleButton: React.FC<ToolbarToggleButtonProps> = ({
  isOpen,
  onToggleState,
  showLabel = 'EventList.show_toolbar',
  hideLabel = 'EventList.hide_toolbar',
  sx,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="outlined"
      // variant="text"
      size="medium"
      onClick={() => onToggleState(!isOpen)}
      endIcon={isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      sx={{
        ml: 1,
        whiteSpace: 'nowrap',
        textTransform: 'uppercase',
        minWidth: '100px',
        justifyContent: 'space-between',
        ...sx,
      }}
      {...props}
    >
      {/* {isOpen ? t(hideLabel) : t(showLabel)} */}
      {t(showLabel)}
    </Button>
  );
};